module.exports = __webpack_public_path__ + "img/c6.dcf493ce.jpg";